import SignaturePad from "signature_pad";


const canvas = document.getElementById("signature-pad");

window.signaturePad = new SignaturePad(canvas);

document.getElementById("clear-signature").addEventListener("click", function () {
  signaturePad.clear();
});

